import * as React from 'react';
import { UIHeading4 } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';
import { useContext } from 'react';

import { FlowRow } from '../../../components/DailyrentNewReview/FlowRow/FlowRow';
import { ENewReviewFlow } from '../../../types/newReview';
import * as styles from './styles.css';
import { selectFlow } from '../../../actions/newReview/flowActions';
import { TThunkDispatch } from '../../../types/redux';
import { goToNextStep } from '../../../actions/newReview';
import { FormModalLayout } from '../../../components/FormLayout';
import { NewReviewContext } from '../../../utils/newReview/context';
import { trackShow } from './tracking';
import { useApplicationContext } from '../../../utils/applicationContext';
import { getObjectId } from '../../../selectors/objectInfo';
import { TripInfoBannerContainer } from '../TripInfoBannerContainer';

export function ReviewFlowContainer() {
  const { custom } = useApplicationContext();
  const objectId = useSelector(getObjectId);
  const { isOpened, onClose } = useContext(NewReviewContext);
  const dispatch = useDispatch<TThunkDispatch>();
  const handleClick = React.useCallback((type: ENewReviewFlow) => {
    dispatch(selectFlow(type));
    dispatch(goToNextStep());
  }, []);

  React.useEffect(() => {
    if (isOpened) {
      trackShow(objectId, custom.deviceType);
    }
  }, [isOpened]);

  return (
    <FormModalLayout
      title="Новый отзыв"
      shortTitle="Новый отзыв"
      onClose={onClose}
      type="form"
      open={isOpened}
      testId="NewReview"
    >
      <div className={styles['root']}>
        <TripInfoBannerContainer />
        <div className={styles['heading']}>
          <UIHeading4>Расскажите про свой опыт</UIHeading4>
        </div>
        <div className={styles['rows']}>
          <FlowRow
            key={ENewReviewFlow.Success}
            type={ENewReviewFlow.Success}
            title="Всё получилось"
            description="Вы оплатили жильё и заселились"
            onClick={handleClick}
          />
          <FlowRow
            key={ENewReviewFlow.Fail}
            type={ENewReviewFlow.Fail}
            title="Брониронироваие отменилось"
            description="Вы или хозяин отменили бронь"
            onClick={handleClick}
          />
          <FlowRow
            key={ENewReviewFlow.FailedToAgree}
            type={ENewReviewFlow.FailedToAgree}
            title="Не подошли условия"
            description="Общались с хозяином и не договорились"
            onClick={handleClick}
          />
        </div>
      </div>
    </FormModalLayout>
  );
}
